export default __webpack_public_path__ + "static/media/kale_red_russian02-2.2353b14d.PNG";